import axios from '../../axios'

export function sessionCountOnline() {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `Sessions/count?where=${encodeURIComponent(
          JSON.stringify({
            and: [{ logOut: null }, { active: true }],
          })
        )}`
      )
      dispatch({
        type: 'SESSION_ONLINE_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'SESSION_ONLINE_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
